import { render } from "./uploadZBFXApproval.vue?vue&type=template&id=1c307e33&scoped=true"
import script from "./uploadZBFXApproval.vue?vue&type=script&lang=js"
export * from "./uploadZBFXApproval.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c307e33"]])

export default __exports__